import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { accessTokenSourceToken } from '@caslink/common-client/ng-app/authentication/AccessTokenSource';
import { AuthenticationService } from './services/authentication.service';

@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ],
    exports: [],
    providers: [
        {
            provide: accessTokenSourceToken,
            useExisting: AuthenticationService
        }
    ]
})
export class UserModule {
}
